import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    const valid = strongPasswordRegex.test(password);
    return valid ? null : { weakPassword: true };
  };
}

// Validador para conferir senhas
export function matchPasswords(
  control: AbstractControl,
): ValidationErrors | null {
  const newPassword = control.get("novaSenha")?.value;
  const confirmPassword = control.get("confirmarNovaSenha")?.value;
  return newPassword === confirmPassword ? null : { passwordsMismatch: true };
}
